import React, { ComponentType } from 'react';
import { inject, observer } from 'mobx-react';
import './homePageHeader.module.scss';
import { ReservableSlotCard } from '../../molecules/reservable/home/ReservableSlotCard';
import { routingStore } from '../../../../common/stores/routing';
import { V3Routes } from '../../../routes';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { TokenType } from '../../../../commonv3/types/tokens';
import moment from 'moment-timezone';
import { SessionType } from '../../../types/sessions';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { MonthlyGoalCard } from '../../molecules/goals/home/MonthlyGoalCard';
import { withNavigation } from '../../hocs/withNavigation';
import { NavigationSpecs } from '../../../states/NavigationState';
import { MultiCreatorReservableSlotCard } from '../../molecules/reservable/home/MultiCreatorReservableSlotCard';
import { MembershipPlanGroupKey } from '../../../types/membershipPlans';

type Props = {
  homeState: HomePageState;
};

export const HomePageHeaderClass = withNavigation(NavigationSpecs.side())(
  inject('homeState')(
    observer(
      class HomePageHeaderClass extends React.Component<Props> {
        render() {
          const { reservationList } = this.props.homeState;
          const { availableTokens, loadState } = GlobalStatesV3.currentUser;
          const coachingToken = availableTokens.findAffordableToken(TokenType.GROUP_COACHING, 1, moment());
          const nextCoachingToken = availableTokens.findAffordableToken(
            TokenType.GROUP_COACHING,
            1,
            moment().add(1, 'month')
          );
          const mokumokuToken = availableTokens.findAffordableToken(TokenType.MOKUMOKU, 1, moment());
          const nextMokumokuToken = availableTokens.findAffordableToken(
            TokenType.MOKUMOKU,
            1,
            moment().add(1, 'month')
          );
          const loading = loadState.submitting;
          const currentUser = GlobalStatesV3.currentUser;
          return (
            <div id="home-page-header" styleName="home-page-header">
              <MonthlyGoalCard loading={loading} onDetailClick={() => routingStore.push(V3Routes.goals())} />
              <div styleName="reservables">
                <ReservableSlotCard
                  title="コーチング"
                  currentToken={coachingToken}
                  nextToken={nextCoachingToken}
                  reservationList={reservationList.findSessionReservationsByType(SessionType.GROUP_COACHING)}
                  text={
                    <>
                      予約はコーチング
                      {GlobalStatesV3.viewport.isSp && <br />}
                      メニューから
                    </>
                  }
                />
                <ReservableSlotCard
                  title="もくもく会"
                  currentToken={mokumokuToken}
                  nextToken={nextMokumokuToken}
                  reservationList={reservationList.findSessionReservationsBy(
                    SessionType.MOKUMOKU,
                    MembershipPlanGroupKey.LIKES
                  )}
                  text={
                    <>
                      予約はもくもく会
                      {GlobalStatesV3.viewport.isSp && <br />}
                      メニューから
                    </>
                  }
                />
                {currentUser.isEffectiveMultiCreatorUser() && (
                  <div>
                    <MultiCreatorReservableSlotCard
                      title="1on1キャリアコーチング"
                      reservationList={reservationList.findSessionReservationsByType(
                        SessionType.MULTICREATOR_CAREER_COACHING
                      )}
                      text={
                        <>
                          予約はコーチング
                          {GlobalStatesV3.viewport.isSp && <br />}
                          メニューから
                        </>
                      }
                    />
                    <MultiCreatorReservableSlotCard
                      title={
                        <>
                          マルチクリエイター
                          {GlobalStatesV3.viewport.isSp && <br />}
                          コース専用もくもく会
                        </>
                      }
                      reservationList={reservationList.findSessionReservationsBy(
                        SessionType.MOKUMOKU,
                        MembershipPlanGroupKey.MULTICREATOR
                      )}
                      text={
                        <>
                          予約はもくもく会
                          {GlobalStatesV3.viewport.isSp && <br />}
                          メニューから
                        </>
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          );
        }
      }
    )
  )
);

export const HomePageHeader = HomePageHeaderClass as ComponentType;
